module.exports = __webpack_public_path__ + "img/charging-hub-request-semipublic.ff1ee83c.svg";